import { configureStore } from '@reduxjs/toolkit'
import auth from './authSlice'
import ui from './uiSlice'
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux'

export const store = configureStore({ reducer: { auth, ui } })

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
